// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"efdf2d78","239":"8ac056da","240":"ba2460c9","455":"d6b419e3","642":"6d01dfc9","675":"80b6e725","719":"384d6e58"}[chunkId] + ".chunk.js";
};